import { actionConstants } from '../actions/actionConstants';
import moment from 'moment';

const initState = {
  loading: false,
  isSubmitting: false,
  currentProfile: {},
  isSessionInitialized: false,
  expired: moment().toDate(),
  apiList: [],
  serverVersion: '',
  errors: '',
  doLogout: false,
  isPwdExpired: false,
};

export default (state = initState, action) => {
  var _state = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case actionConstants.PASSWORD_IS_EXPIRED:
      return { ...state, isPwdExpired: action.data };
    case actionConstants.CLEAR_ERROR:
      return { ...state, errors: '' };
    case actionConstants.START_QUERY:
      return { ...state, errors: '', loading: true };
    case actionConstants.END_QUERY:
      return { ...state, loading: false };
    case actionConstants.START_SUBMISSION:
      return { ...state, errors: '', isSubmitting: true };
    case actionConstants.END_SUBMISSION:
      return { ...state, isSubmitting: false };
    case actionConstants.GET_CURRENT_PROFILE_SUCCESS:
      return { ...state, currentProfile: action.data };
    case actionConstants.GET_CURRENT_PROFILE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.UPDATE_CURRENT_PROFILE_SUCCESS:
      return { ...state, currentProfile: Object.assign({}, action.data) };
    case actionConstants.UPDATE_CURRENT_PROFILE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.INIT_SESSION:
      return { ...state, expired: action.data, isSessionInitialized: true };
    case actionConstants.RESET_SESSION:
      return { ...state, expired: action.data };
    case actionConstants.LOG_API:
      return { ...state, apiList: action.data };
    case actionConstants.DESTROY_SESSION:
      return { ...state, isSessionInitialized: false };
    case actionConstants.NEED_LOGOUT:
      return { ...state, doLogout: action.data };
    case actionConstants.GET_SERVER_VERSION_SUCCESS:
      return { ...state, serverVersion: action.data };
    case actionConstants.GET_SERVER_VERSION_FAILURE:
      return { ...state, errors: action.data };
    default:
      return _state;
  }
};
